module.exports = __webpack_public_path__ + "static/img/weather_cloudy.fb83711.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather_cloudy.png
// module id = y9/a
// module chunks = 2